export default {
  id: 'TeacherDockInfo',
  code: 'CN',
  text: {
    'Info': '老师档案',
    'Courses': '课程记录',
    'Attendance': '签到记录',
    'Clock Card': '打卡记录',

    'Name': '姓名',
    'Gender': '性别',
    'Phone': '联系电话',
    'Email': '联系邮箱',

    'Current Class': '当期班级',
    'Past Class': '结业班级',
    'Class': '班级',
    'Exit Class': '退班',

    'Proceed to exit teacher from class?': '确认将老师退班？',

    'Basic Info': '基本信息',
    'Edit': '编辑',
    'Delete': '删除',
    'Teacher Description':'老师简介',

    'Clock In/Out': '打卡',
    'Proceed to delete this record?': '确认删除此纪录？',
    'Date': '日期',
    'Time': '时间',
    'Clock In/Clock Out': '上班/下班',
    'Operator': '操作者',
    'Clock In': '上班',
    'Clock Out': '下班',
    'Principal': '校长',
    'Calculate Salary': '计算工资',
    'Work Start Time': '工作开始时间',
    'Work End Time': '工作结束时间',
    'Working Days': '工作日期',
    'Work End Time must be later than Work Start Time': '工作结束时间必须晚于工作开始时间',
    'Monday': '星期一',
    'Tuesday': '星期二',
    'Wednesday': '星期三',
    'Thursday': '星期四',
    'Friday':'星期五',
    'Saturaday': '星期六',
    'Sunday': '星期日',
    'Total Salary': '总工资',
    'Get Statistic': '获取统计',
    'Total Work Duration': '总工作时间',
    'Abnormal Amount': '打卡异常数',
    'Absent Amount': '缺勤数',
    'Absent Duration': '缺勤时间',
    'Late Amount': '迟到数',
    'Late Duration': '迟到时间',
    'Leave Early Amount': '早退数',
    'Leave Early Duration': '早退时间',
    'times': '次',
    'h': '小时',
    'Male': '男',
    'Female': '女',
    'Others': '其他',
    'N/A': '未提供'
  }
}



// WEBPACK FOOTER //
// ./src/template/Docks/TeacherInfo/locale.js